import {Injectable} from '@angular/core';
import {Http, Response} from '@angular/http';
import {Observable} from "rxjs";
import {Menu, MenuPayload} from "../classes/menu";
import {Product, ProductPayload} from "../classes/product";
import {Customer} from "../classes/customer";
import {IOpenStatus} from "../interfaces/open_status";
import { Dialog } from '@capacitor/dialog';
import {CUSTOMER_NAME, COMPLETE_PAYLOAD} from "../constants/config";
import {HTTP} from "@ionic-native/http";
import {ProductSpecial} from "../classes/product_special";
import {observable} from "rxjs/symbol/observable";

@Injectable()
export class API {
  public static BASE_HOST =  "https://v1.mainorder.de"; //TODO get .env var
  static request = location.search;
  public static CUSTOMER =  API.request == "" ? CUSTOMER_NAME : new URLSearchParams(API.request).get("customer");
  public static isWebApp = API.request != "";

  constructor(private http: Http, private http2 : HTTP) {

  }

  static concat(...parts){
    return `${API.BASE_HOST}${parts.join('/')}`
  }

  sendVerificationCode(phonenumber: string): Observable<Response> {
    return this.http.post(
      `${API.BASE_HOST}/customers/${API.CUSTOMER}/modules/users/register/`, {
        phonenumber,
        type: "sms"
      }
    )
  }

  getMessages(){
    return this.http.get(
      `${API.BASE_HOST}${(COMPLETE_PAYLOAD as any).messages}`
    ).map(res => res.json())
  }



  getStaticPage(pageName: string) {
    return this.http.get(
      `${API.BASE_HOST}/customers/${API.CUSTOMER}/seiten/${pageName}/`).map(this.parsePage);
  }

  parsePage(response: Response) {
    return response.json();
  }

  verifyCode(code: string, phonenumber: string): any {
    return this.http.post(
      `${API.BASE_HOST}/customers/${API.CUSTOMER}/modules/users/verify/`, {
        phonenumber,
        code,
        type: "sms"
      }, {}).map(res => res.json());
  }

  getProducts(menu: Menu): Observable<Product[]> {
    return this.http.get(
      `${API.BASE_HOST}/${menu.url}`
    ).map(this.parseProducts)
      .catch(this.handleError);
  }

  getOpeningTimes() {
    return this.http.get(
      `${API.BASE_HOST}/customers/${API.CUSTOMER}`
    ).map(this.parseCustomer)
      .catch(this.handleError);
  }


  getProduct(product: Product): Observable<Response> {
    return this.http.get(
      `${API.BASE_HOST}/customers/${API.CUSTOMER}`
    );
  }

  getCustomer(): Observable<Customer> {
    return this.http.get(
      `${API.BASE_HOST}/customers/${API.CUSTOMER}`
    ).map(this.parseCustomer)
  }

  getMenus(): Observable<Menu[]> {
    return this.http.get(`${API.BASE_HOST}/customers/${API.CUSTOMER}/kategorien/`)
      .map(this.parseMenus)
      .catch(this.handleError);
  }

  private parseMenus(res: Response): Menu[] {
    return res.json().map((payload: MenuPayload) => {
      return new Menu(payload);
    });
  }

  isOpen(){
    return this.http.get(`${API.BASE_HOST}/customers/${API.CUSTOMER}/modules/restaurant/open/`)
      .map(this.parseIsOpen)
      .catch(this.handleError);
  }

  private parseIsOpen(res : Response) : IOpenStatus {
    // if (window.location.href.includes('localhost:8100')){
    //   return {"closed":false,"opened":true,"delivery":true};
    // }
    return res.json() as IOpenStatus;
  }

  private parseProducts(res: Response): Product[] {
    const data = res.json();
    return data.products.map((payload: ProductPayload) => {
      if (payload.type === "product") {
        return new Product(payload, new Menu(data.category));
      }

      if (payload.type === "product-special"){
        return new ProductSpecial(payload as any, new Menu(data.category));
      }

      return new Product(payload, new Menu(data.category));
    });
  }

  private parseCustomer(res: Response): Customer {
    return new Customer(res.json());
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    if (Dialog)
      Dialog.alert({
        message: "Ein Fehler ist während der Verbindung zum Server aufgetreten, bitte versuche es erneut",
        title: "Fehler"
      });
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts